import { useStore } from '@nanostores/react'
import { Dialog as DialogPrimitives } from 'radix-ui'
import { GradientBorderBox } from '~/components/gradient-border'
import { Spinner } from '~/components/ui/spinner'
import { $dialog, dialog } from '~/store/dialog'

export function Dialog() {
  const dialogState = useStore($dialog)

  const handleButtonClick = () => {
    if (dialogState.dialog.asyncAction) {
      dialogState.dialog.asyncAction()
    } else {
      dialogState.dialog.action?.()
      dialog.close()
    }
  }

  return (
    <DialogPrimitives.Root
      open={dialogState.isOpen}
      onOpenChange={(nextIsOpen) => {
        if (!nextIsOpen && !dialogState.isLoading) dialog.close()
      }}
    >
      <DialogPrimitives.Portal>
        <DialogPrimitives.Overlay className="fixed inset-0 z-[55] bg-black/10 backdrop-blur-[12.5px] data-[state=open]:animate-in data-[state=closed]:animate-out data-[state=closed]:fade-out-0 data-[state=open]:fade-in-0" />
        <DialogPrimitives.Content
          className="fixed left-1/2 top-1/2 z-[60] w-[calc(100vw-48px)] max-w-[345px] -translate-x-1/2 -translate-y-1/2 data-[state=open]:animate-in data-[state=closed]:animate-out data-[state=closed]:fade-out-0 data-[state=open]:fade-in-0"
          onPointerDownOutside={(event) => event.preventDefault()}
          onInteractOutside={(event) => event.preventDefault()}
          onOpenAutoFocus={(event) => event.preventDefault()}
          onEscapeKeyDown={(event) => event.preventDefault()}
          style={{
            ['--tw-enter-translate-x' as any]: '-50%',
            ['--tw-enter-translate-y' as any]: '-50%',
            ['--tw-exit-translate-x' as any]: '-50%',
            ['--tw-exit-translate-y' as any]: '-50%',
          }}
        >
          <GradientBorderBox
            className="bg-white/70 backdrop-blur-[50px]"
            radius={32}
            borderWidth={2}
            style={{
              willChange: 'backdrop-filter',
            }}
          >
            <div className="p-6 text-center">
              <DialogPrimitives.DialogTitle className="text-lg font-semibold text-[#333]">
                {dialogState.dialog.title}
              </DialogPrimitives.DialogTitle>

              <DialogPrimitives.DialogDescription className="mt-3 whitespace-pre-line text-[#666]">
                {dialogState.dialog.description}
              </DialogPrimitives.DialogDescription>

              {dialogState.dialog.asyncAction ? (
                <button
                  className="relative mt-4 flex h-[52px] w-full items-center justify-center rounded-xl bg-[#176361] font-bold text-white disabled:bg-[#639897]"
                  onClick={handleButtonClick}
                  disabled={dialogState.isLoading}
                >
                  {dialogState.isLoading && (
                    <Spinner className="absolute right-7 text-[#176361]" />
                  )}
                  {dialogState.dialog.button}
                </button>
              ) : (
                <DialogPrimitives.Close asChild>
                  <button
                    className="mt-4 h-[52px] w-full rounded-xl bg-[#176361] font-bold text-white"
                    {...(dialogState.dialog.action && {
                      onClick: () => dialogState.dialog.action!(),
                    })}
                  >
                    {dialogState.dialog.button}
                  </button>
                </DialogPrimitives.Close>
              )}
            </div>
          </GradientBorderBox>

          {dialogState.dialog.closeButton && !dialogState.isLoading && (
            <DialogPrimitives.Close
              className="absolute right-[-10px] top-[-10px] grid size-[42px] place-items-center overflow-hidden rounded-full backdrop-blur-[37.5px]"
              style={{
                background: 'rgba(255, 255, 255, 0.56)',
              }}
              onClick={() => {
                if (typeof dialogState.dialog.closeButton === 'object') {
                  dialogState.dialog.closeButton.action()
                }
              }}
            >
              <CloseSvg />
            </DialogPrimitives.Close>
          )}
        </DialogPrimitives.Content>
      </DialogPrimitives.Portal>
    </DialogPrimitives.Root>
  )
}

function CloseSvg() {
  return (
    <svg
      width="19"
      height="18"
      viewBox="0 0 19 18"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M5.21429 4.71442L13.7857 13.2858"
        stroke="#333333"
        strokeWidth="1.3"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M5.21427 13.2858L13.7856 4.71442"
        stroke="#333333"
        strokeWidth="1.3"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  )
}
